import { Typography } from '@mui/material'
import { RailVisitTrackAndTimingFormStore } from '@planning/pages/RailVisit/stores/RailVisitTrackAndTimingFormStore'
import { useTranslate } from '@tolgee/react'
import { DataControlCard, DataControlCardProps, RequiredField, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { RailVisitTrackAndTimingSubForm } from './RailVisitTrackAndTimingSubForm'
import { RailVisitTrackAndTimingViewMode } from './RailVisitTrackAndTimingViewMode'

type RailVisitTrackAndTimingControlCardProps = {
  railVisitTrackAndTimingFormStore: RailVisitTrackAndTimingFormStore
  isEditMode: boolean
} & Partial<DataControlCardProps>

export const RailVisitTrackAndTimingControlCard: FC<RailVisitTrackAndTimingControlCardProps> =
  observer(props => {
    const { railVisitTrackAndTimingFormStore, isEditMode } = props
    const { t } = useTranslate()
    const theme = useMinimalsTheme()

    return (
      <DataControlCard
        {...props}
        title={
          <>
            {t('trackAndTimings', 'Track & timings')} <RequiredField />
          </>
        }
        autoFocusId='eta'
        dataCy='rail-track-and-timings'
        viewComponent={
          railVisitTrackAndTimingFormStore ? (
            <RailVisitTrackAndTimingViewMode store={railVisitTrackAndTimingFormStore} />
          ) : (
            <Typography variant='body2' color={theme.palette.text.secondary}>
              {t('noInformationYet', 'No information yet')}
            </Typography>
          )
        }
        editComponent={
          <RailVisitTrackAndTimingSubForm
            store={railVisitTrackAndTimingFormStore}
            hideTypeSelector={isEditMode}
          />
        }
        // isEditMode here referes to the edit mode of the page, not the card
        defaultEditMode={!isEditMode}
      />
    )
  })
